import type { CourseListFilterSchema } from './schema.ts';
import { FormattedMessage } from 'react-intl';
import { labelCommonI18n } from '@_/i18n-common';
import { StackedLayout, StackedLayoutSection } from '@_/ui';
import { CurriculumFilter } from '#src/components/filters/CurriculumFilter.tsx';
import { DistrictFilter } from '#src/components/filters/DistrictFilter.tsx';
import { labelI18n } from '#src/i18nMessages/index.ts';

export function CourseListFilterMenu({
  disabled = false,
  onChange,
  showCurriculumFilter = true,
  value
}: {
  disabled?: boolean;
  onChange?: (value: CourseListFilterSchema) => void;
  showCurriculumFilter?: boolean;
  value: CourseListFilterSchema;
}) {
  return (
    <StackedLayout size="sm">
      <StackedLayoutSection heading={<FormattedMessage {...labelI18n.districts} />} initialOpen>
        <DistrictFilter
          disabled={disabled}
          onChange={countryZoneCodes => {
            onChange?.({ ...value, countryZoneCodes });
          }}
          value={value.countryZoneCodes}
        />
      </StackedLayoutSection>

      {showCurriculumFilter && (
        <StackedLayoutSection
          heading={<FormattedMessage {...labelCommonI18n.curriculum} />}
          initialOpen
        >
          <CurriculumFilter
            disabled={disabled}
            onChange={({ academicLevelIds, curriculumIds }) => {
              onChange?.({ ...value, academicLevelIds, curriculumIds });
            }}
            value={{
              academicLevelIds: value.academicLevelIds,
              curriculumIds: value.curriculumIds
            }}
          />
        </StackedLayoutSection>
      )}
    </StackedLayout>
  );
}
